import type { Note } from "./api";

export type JotSort = "new" | "old" | "star";

export const JOT_SORTS: { key: JotSort; label: string }[] = [
  { key: "new", label: "Newest" },
  { key: "old", label: "Oldest" },
  { key: "star", label: "Starred" },
];

/** Sort a day's jots. "star" floats starred to the top, then newest-first. */
export function sortJots(list: Note[], mode: JotSort): Note[] {
  const byNewest = (a: Note, b: Note) => b.createdAt.localeCompare(a.createdAt);
  const arr = [...list];
  if (mode === "old") arr.sort((a, b) => a.createdAt.localeCompare(b.createdAt));
  else if (mode === "star")
    arr.sort((a, b) => (a.pinned !== b.pinned ? (a.pinned ? -1 : 1) : byNewest(a, b)));
  else arr.sort(byNewest);
  return arr;
}

export function readJotSort(): JotSort {
  const v = typeof localStorage !== "undefined" ? localStorage.getItem("jotsSort") : null;
  return v === "old" || v === "star" ? v : "new";
}

export function writeJotSort(mode: JotSort): void {
  if (typeof localStorage !== "undefined") localStorage.setItem("jotsSort", mode);
}
